export default __webpack_public_path__ + "static/media/french_flag.944a718a.svg";